/* eslint-disable jsx-a11y/role-supports-aria-props */
/* eslint-disable no-script-url,jsx-a11y/anchor-is-valid */
import React, { useRef, useState, useEffect } from "react";
import { useLocation } from "react-router";
import { NavLink, HashRouter, useHistory } from "react-router-dom";
// import SVG from "react-inlinesvg";
import { toAbsoluteUrl, checkIsActive } from "../../../../_helpers";
import SvgCmp from "../../../../../app/components/svg/SvgCmp";
import ListAltIcon from "@mui/icons-material/ListAlt";
import { useDispatch, useSelector } from "react-redux";
import { setStep } from "../../../../../app/redux/activeStep/activeStepAction";
import {
  getJwtToken,
  getTokenClaims,
} from "../../../../../app/services/auth.service";
import { GetWorkflowTypesResponse } from "../../../../../app/models/cartable.model";
import { GetWorkflowTypes } from "../../../../../app/services/cartable.service";
import { useQuery, useQueryClient } from "react-query";
import { ACTIVE_DIV, WORK_FLOW_TYPE } from "../../../../../app/config/cacheKey";
import { cartableSet } from "../../../../../app/redux/activeCartable/activeCartableSlice";
import { setDashboardLoader } from "../../../../../app/redux/dashboardLoader/dashboardLoaderAction";
import ContentPasteIcon from "@mui/icons-material/ContentPaste";
import { GetSideMenu } from "../../../../../app/models/security.model";
import { GetMenus } from "../../../../../app/services/security.service";
import ArrowBackIosIcon from "@mui/icons-material/ArrowBackIos";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { Grid } from "@mui/material";
import SummarizeIcon from "@mui/icons-material/Summarize";
import StorefrontIcon from "@mui/icons-material/Storefront";
import { BasePowerBIURL } from "../../../../../app/config/config";
import version from "../../../../../../package.json";
import { InputAdornment, makeStyles } from "@material-ui/core";
import {
  getTablePage,
  getTableSelectedRow,
} from "../../../../../app/redux/table/tableSlice";

export function AsideMenuList({
  layoutProps,
  setRefreshQuickCartable,
}: {
  layoutProps: any;
  setRefreshQuickCartable: any;
}) {
  const jsonFile = useSelector((state: any) => state.style);

  const location = useLocation();

  const getMenuItemActive = (
    url: string,
    hasSubmenu = false,
    workflowType = ""
  ) => {
    let tt = checkIsActive(location, url);
    const test = checkIsActive(location, url)
      ? ` ${!hasSubmenu &&
          "menu-item-active"} menu-item-open menu-item-not-hightlighted`
      : "";
    if (!hasSubmenu && test != "") {
      //check ???
      // localStorage.setItem("setActivePage", workflowType);
    }
    return test;
  };
  const dispatch = useDispatch();
  const handelStep = () => {
    dispatch(setStep({ step: 0 }));
  };

  const queryClient = useQueryClient();
  const history = useHistory();
  const canModifyUser = String(getTokenClaims()?.canModifyUser);

  let { data, isLoading } = useQuery<GetWorkflowTypesResponse[]>(
    "GetWorkflowTypes",
    (): Promise<GetWorkflowTypesResponse[]> => {
      return GetWorkflowTypes();
    },
    { enabled: getJwtToken() != null }
  );

  let { data: sideMenu, isLoading: sideMenuLoading } = useQuery<GetSideMenu>(
    "GetSideMenus",
    (): Promise<GetSideMenu> => {
      return GetMenus();
    },
    { enabled: getJwtToken() != null }
  );

  let value;
  if (isLoading) {
    return <></>;
  } else {
    if (data != null) {
      if (data.length > 0) data[0].state = "success";
      value = data;
    }
  }

  const handleFlowType = (workflowType: string) => {
    dispatch(cartableSet({ cartable: workflowType }));
    // history.push(`/loan/${workflowType}`);
    history.push({
      pathname: `/loan/${workflowType}`,
      state: { refetchStatus: true },
      // search: "test",
    });
    queryClient.setQueryData(ACTIVE_DIV, 0);
    setRefreshQuickCartable(true);
    queryClient.setQueryData(WORK_FLOW_TYPE, workflowType);

    localStorage.setItem("setActivePage", workflowType);

    queryClient.setQueryData("table_filter", null);
    queryClient.setQueryData("national", null);
    queryClient.setQueryData("supplier_id", null);
    // getMenuItemActive(
    //   "/loan/loan-list",
    //   false
    // )
  };

  const handleFlowType_setting = (workflowType: string) => {
    dispatch(cartableSet({ cartable: workflowType }));
    // history.push(`/loan/${workflowType}`);
    history.push({
      pathname: `/setting/${workflowType}`,
    });
    queryClient.setQueryData(WORK_FLOW_TYPE, workflowType);
    localStorage.setItem("setActivePage", workflowType);

    queryClient.setQueryData("table_filter", null);
    queryClient.setQueryData("national", null);
    queryClient.setQueryData("supplier_id", null);
  };
  const handleFlowType_search = (workflowType: string) => {
    dispatch(cartableSet({ cartable: workflowType }));
    //history.replace(`/loan/${workflowType}`);
    history.action = "REPLACE";
    queryClient.setQueryData(WORK_FLOW_TYPE, workflowType);
    localStorage.setItem("setActivePage", workflowType);
    queryClient.setQueryData("table_filter", null);
    queryClient.setQueryData("national", null);
    queryClient.setQueryData("supplier_id", null);
    setRefreshQuickCartable(false);
    // getMenuItemActive(
    //   "/loan/loan-list",
    //   false
    // )
  };
  const css = `
  .aside-menu .menu-nav>.menu-item.menu-item-open>.menu-link {
    background: ${jsonFile?.mainColor} !important; 
 }
.aside-menu .menu-nav>.menu-item .menu-submenu .menu-item.menu-item-active>.menu-link {
  background: ${jsonFile?.mainColor} !important; 
};
`;
  return (
    <>
      <style>{css}</style>
      <HashRouter>
        {/* begin::Menu Nav */}
        <ul className={`menu-nav ${layoutProps.ulClasses}`}>
          <li
            className={`menu-item menu-item-submenu ${getMenuItemActive(
              "/loan2",
              true
            )}`}
            aria-haspopup="true"
            data-menu-toggle="hover"
          >
            {data ? (
              <NavLink className={`menu-link menu-toggle `} to="/loan">
                <span className={`svg-icon menu-icon `}>
                  {/* {<SVG src={toAbsoluteUrl("/media/svg/icons/Design/Cap-2.svg")} />} */}
                  <SvgCmp src="/media/svg/icons/Design/Cap-2.svg" />
                  <ContentPasteIcon className="iconeSide" />
                </span>
                <span className="menu-text"> کارتابل</span>
                <i className="menu-arrow" />
              </NavLink>
            ) : null}

            <div className="menu-submenu ">
              <i className="menu-arrow" />
              <ul className="menu-subnav">
                {/*begin::3 Level*/}
                {data?.map((item: any, index: number) => (
                  <li
                    className={`menu-item ${getMenuItemActive(
                      `/loan/${item.workflowType}`,
                      false,
                      item.workflowType
                    )}`}
                    aria-haspopup="true"
                  >
                    <div
                      className="menu-link"
                      onClick={() => handleFlowType(item.workflowType)}
                    >
                      <i className="menu-bullet menu-bullet-dot">
                        <ListAltIcon className="iconeSide" />
                      </i>
                      <span className="menu-text " style={{ fontSize: "12px" }}>
                        {item.workflowTitle}
                      </span>
                    </div>
                  </li>
                ))}
              </ul>
            </div>
          </li>
          {/* <li
            className={`menu-item menu-item-submenu ${getMenuItemActive(
              "/setting",
              true
            )}`}
            aria-haspopup="true"
            data-menu-toggle="hover"
          >
            <NavLink className="menu-link menu-toggle" to="/setting">
              <span className="svg-icon menu-icon">
                <SvgCmp src="/media/svg/icons/Design/Cap-2.svg" />
                <SummarizeIcon className="iconeSide" />
              </span>
              <span className="menu-text"> تنظیمات</span>
              <i className="menu-arrow" />
            </NavLink>

            <div className="menu-submenu ">
              <i className="menu-arrow" />
              <ul className="menu-subnav">
                <li
                  className={`menu-item ${getMenuItemActive(
                    `/setting`,
                    false,
                    "notificationList"
                  )}`}
                  aria-haspopup="true"
                >
                  <NavLink
                    className="menu-link menu-toggle"
                    to="/setting/notificationList"
                    onClick={() => handleFlowType_setting("notificationList")}
                  >
                    <i className="menu-bullet menu-bullet-dot">
                      <StorefrontIcon className="iconeSide" />
                    </i>
                    <span className="menu-text">اطلاعیه</span>
                  </NavLink>
                </li>
              </ul>
            </div>
          </li> */}

          {
            <li
              className={`menu-item menu-item-submenu `}
              aria-haspopup="true"
              data-menu-toggle="hover"
            >
              <TreeView sideMenu={sideMenu} jsonFile={jsonFile} />
            </li>
          }
        </ul>
      </HashRouter>
      <div style={{ position: "fixed", bottom: 0, color: "#716e6e7a" }}>
        v{version.version}
      </div>
      {/* end::Menu Nav */}
    </>
  );
}

const TreeNode = (props: any) => {
  // const loadedData = JSON.stringify(jsonFile);
  // const json = JSON.parse(loadedData);

  const dispatch = useDispatch();
  const history = useHistory();
  const [isExpanded, setIsExpanded] = useState(false);
  const objectStyleMenu = {
    // paddingRight: "20px",
  };
  const objectStyle = {
    paddingRight: "0px",
  };
  const handleToggle = () => {
    setIsExpanded(!isExpanded);
  };
  const setRouteForDetailPage = (route: string, node: any) => {
    const routeSplit = route.slice(8);

    localStorage.setItem("setActivePage", routeSplit);

    let isDashboardRoute = route.includes(BasePowerBIURL);

    if (isDashboardRoute) {
      dispatch(setDashboardLoader({ BIURL: route, BIID: node.id }));

      if (node.name === "BIManagement") {
        window?.open(route, "blank")?.focus();
      } else {
        //sif (node.name.includes("Income")) {
        localStorage.setItem("BiActivePage", props.node.name);
        var headerValue = JSON.stringify(props.node);
        localStorage.setItem("BIHeaderTitle", headerValue);
      }
      // else {
      //   localStorage.setItem("BiActivePage", props.node.name);
      //   localStorage.setItem("BIHeaderTitle", "");

      // }
    } else {
      localStorage.setItem("BiActivePage", ""); // props.node.name);
      localStorage.setItem("BIHeaderTitle", "");
    }
  };
  const location = useLocation();
  const route = props.node.route;

  const handleClickSubMenu = (route: string, node: any) => {
    dispatch(getTableSelectedRow({ selectedRowNum: undefined }));
    dispatch(getTablePage({ selectedPageNum: 1 }));
    setRouteForDetailPage(route, props.node);
  };
  const jsonFile = useSelector((state: any) => state.style);

  return (
    <div
      className={` tree-node  menu-nav colorFFF ${
        isExpanded && props.node.route != "#" && !props.node.parentId
          ? jsonFile?.selectedAsideMenuColor
          : ""
      }  `}
      style={
        props.node.route == "#" || props.node.parentId == null
          ? objectStyle
          : objectStyleMenu
      }
    >
      <div
        onClick={handleToggle}
        className={`node-toggle4  ${isExpanded ? "expanded " : ""}  ${
          // isExpanded &&
          // props.node.route != "#" &&
          //props.node.name.includes("Income")?" BgChild":

          // location.pathname.includes(props.node.route)
          //   ? " BgChild"
          //   : "colorSide"

          location.pathname.includes(props.node.route)
            ? jsonFile?.selectedAsideMenuColor
            : props.node.name == localStorage.getItem("BiActivePage")
            ? jsonFile?.selectedAsideMenuColor
            : jsonFile?.asideMenuColor
            ? jsonFile.asideMenuColor
            : "colorSide"
        }
      ${
        isExpanded && props.node.route == "#"
          ? jsonFile.selectedAsideMenuColor
          : ""
      }
         
          `}
      >
        <NavLink
          style={{ marginRight: "0px", fontSize: "12px" }}
          className="menu-arrow menu-text"
          to={
            route.includes(BasePowerBIURL)
              ? //props.node.name
                "/dashboadLoader"
              : props.node.route
          }
          onClick={() => handleClickSubMenu(route, props.node)} //setRouteForDetailPage(route, props.node)}
        >
          <Grid container spacing={2}>
            <Grid item xs={2}>
              {props.node.subMenus.length > 0 || !props.node.parentId ? (
                <img
                  src={`images/${props.node.icon}.png`}
                  className="iconeSide"
                  style={{ padding: "0 23px 0 40px" }}
                  alt=""
                />
              ) : (
                <img
                  src={`images/${props.node.icon}.png`}
                  className="iconeSideSub "
                  style={{
                    padding: "0 40px 0 50px",
                  }}
                  alt=""
                />
              )}
            </Grid>

            {props.node.subMenus.length > 0 || !props.node.parentId ? (
              <>
                <Grid item xs={7}>
                  <span
                    className="menu-text hideIcone_MinimizeSide"
                    style={{
                      marginRight: "10px",
                      display: "inline-block",
                      marginTop: "3px",
                    }}
                  >
                    {" "}
                    {props.node.title}
                  </span>{" "}
                </Grid>
                <Grid item xs={3}>
                  {isExpanded && props.node.route == "#" ? (
                    <ExpandMoreIcon
                      className="hideIcone_MinimizeSide"
                      style={{
                        fontSize: "16px",
                        color: "#fff",
                        marginRight: "21px",
                      }}
                    />
                  ) : !isExpanded && props.node.route == "#" ? (
                    <ArrowBackIosIcon
                      className="hideIcone_MinimizeSide"
                      style={{
                        fontSize: "10px",
                        color: "gray",
                        marginRight: "21px",
                      }}
                    />
                  ) : null}
                </Grid>
              </>
            ) : (
              <Grid item xs={10}>
                <span
                  className="hideIcone_MinimizeSide"
                  style={{ marginRight: "20px" }}
                >
                  {" "}
                  {props.node.title}
                </span>
              </Grid>
            )}
          </Grid>
        </NavLink>
      </div>
      {isExpanded && (
        <ul
          className={`${isExpanded ? "child-nodes" : "child-nodes_"}`}
          style={{
            listStyleType: "none",
            // paddingRight: "20px",
          }}
        >
          {props.node.subMenus.map((childNode: any) => (
            <li
              key={childNode.id}
              className={`menu-item menu-item-submenu `}
              aria-haspopup="true"
              data-menu-toggle="hover"
            >
              <TreeNode node={childNode} />
            </li>
          ))}
        </ul>
      )}
    </div>
  );
};

const TreeView = (props: any) => {
  return (
    <div className="hoverMenu menu-item-active">
      {props.sideMenu
        ? props.sideMenu.map((rootNode: any) => (
            <div>
              <TreeNode
                key={rootNode.id}
                node={rootNode}
                jsonFile={props.jsonFile}
              />
            </div>
          ))
        : null}
    </div>
  );
};
